export const CLIENT_PORTAL_URL = import.meta.env.VITE_CLIENT_PORTAL_URL;
export const COAST_VOICE_PHONE = import.meta.env.VITE_COAST_VOICE_PHONE;
export const COAST_SUPPORT_EMAIL = import.meta.env.VITE_COAST_SUPPORT_EMAIL;
export const VGS_INBOUND_URL = import.meta.env.VITE_VGS_INBOUND_URL;
export const NEUROID_SCRIPT_URL = import.meta.env.VITE_NEUROID_SCRIPT_URL;
export const DATADOG_ENABLED = import.meta.env.VITE_DATADOG_ENABLED === 'true';
export const LOGROCKET_ENABLED = import.meta.env.VITE_LOGROCKET_ENABLED === 'true';
export const LOGROCKET_APP_ID = import.meta.env.VITE_LOGROCKET_APP_ID;
export const ENABLE_MSW = import.meta.env.VITE_ENABLE_MSW === 'true';
export const IS_DEV = import.meta.env.DEV;
